import moment from 'moment'

export const ObdelavaDatuma = {
  methods: {
    // funkcija prejme vhodni parameter primer(2019-12)
    // vrača objekt z začetnim in končnim datumom meseca
    // primer(izbranoObdobje.trajanjeOd 2019-12-01 izbranoObdobje.trajanjeDo 2020-01-01)
    DolociIzbranMesec (izbranMesec) {
      let izbranoObdobje = {}
      let trajanjeOd = null
      if (typeof izbranMesec !== 'undefined' && izbranMesec !== null) {
        trajanjeOd = new Date(izbranMesec)
      } else {
        trajanjeOd = new Date(moment(this.izbranMesec, 'YYYY-MM').toDate())
      }
      let trajanjeDo = new Date(trajanjeOd.getFullYear(), trajanjeOd.getMonth() + 1, 0)
      /* datum od */
      let dan = trajanjeOd.getDate()
      let mesec = trajanjeOd.getMonth() + 1
      if (dan < 10) {
        dan = '0' + dan
      }
      if (mesec < 10) {
        mesec = '0' + mesec
      }
      izbranoObdobje.trajanjeOd = trajanjeOd.getFullYear() + '-' + mesec + '-' + dan
      /* datum do */
      let letoDo = trajanjeDo.getFullYear()
      mesec = trajanjeDo.getMonth() + 2
      if (mesec < 10) {
        mesec = '0' + mesec
      } else if (mesec > 12) {
        mesec = '01'
        letoDo++
      }
      izbranoObdobje.trajanjeDo = letoDo + '-' + mesec + '-' + '01'
      return izbranoObdobje
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/IzbiraMeseca.js